import { useIntegrations } from "@/features/integrations/hooks/useIntegrations";

export function useIntegrationNames() {
  const { data: integrations } = useIntegrations();
  return integrations?.map((integration) => integration.name) ?? [];
}
